import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AuthProvider } from './auth/AuthContext';
import { SidebarProvider } from './contexts/SidebarContext';
import { ToastProvider } from './components/ui/toast';
import { router } from './router';
import './index.css';

// Create a client for React Query
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      gcTime: 1000 * 60 * 10, // 10 minutes (formerly cacheTime)
    },
  },
});

const rootElement = document.getElementById('root');

if (rootElement) {
  createRoot(rootElement).render(
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <SidebarProvider>
          <ToastProvider>
            <RouterProvider router={router} />
          </ToastProvider>
        </SidebarProvider>
      </AuthProvider>
    </QueryClientProvider>
  );
}
